<template>
  <div style="margin-top: 30px; margin-right: 15px">
    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <!-- <el-form-item label="装货时间" prop="time">
        <el-date-picker
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="form.time"
          type="datetime"
          placeholder="选择"
        />
      </el-form-item> -->
      <el-form-item label="货物吨位" prop="weight">
        <el-input
          v-model="form.weight"
          @input="(value) => formFormatter.isFloor3(value,oldValue, form, 'weight')"
        >
          <template slot="append"> 吨 </template>
        </el-input>
      </el-form-item>
      <el-form-item v-if="form.coalUnit != 0" label="货物数量" prop="quantity">
        <el-input
          v-model="form.quantity"
          @input="
            (value) =>
              form.coalUnitName == '件'
                ? formFormatter.isInteger(value,oldValue, form, 'quantity')
                : formFormatter.isFloor3(value,oldValue, form, 'quantity')
          "
        >
          <template slot="append">
            {{ form.coalUnitName }}
          </template>
        </el-input>
      </el-form-item>
      <el-form-item label="装货单据" prop="imgUrl">
        <ImgWatermark
          :upload-config="{ prefix: '装货交接单', form: imageFrom }"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel"> 取 消 </el-button>
      <el-button type="primary" @click="funcSubmit"> 确 定 </el-button>
    </div>
  </div>
</template>
<script>
import ImgWatermark from "@/components/ImgWatermark";
import { orderDetailfill } from "@/api/transport";
import { parseTime } from "@/utils";
import { maxNumber } from "@/utils/validate4Form.js";

export default {
  components: {
    ImgWatermark,
  },
  data() {
    return {
      pageType: "load",
      image: [],
      form: {
        time: "",
        weight: "",
        quantity: "",
        imgUrl: "",
      },
      rules: {
        time: [{ required: true, message: "请选择装货时间", trigger: "blur" }],
        weight: [
          {
            required: true,
            message: "请输入货物吨位",
            trigger: "blur",
          },
          {
            validator: maxNumber,
            trigger: "blur",
          },
        ],
        quantity: [
          { required: true, message: "请输入货物数量", trigger: "blur" },
          { validator: maxNumber, trigger: "blur" },
        ],
      },
      imageFrom: {
        renche: "",
        jiaojie: "",
        imageObj: [],
      },
    };
  },
  methods: {
    init(entity) {
      this.$set(this.form, "coalUnit", entity.coalUnit);
      this.$set(this.form, "coalUnitName", entity.coalUnitName);
      this.$set(this.form, "code", entity.code);
      this.$set(this.imageFrom, "renche", "");
      this.$set(this.imageFrom, "jiaojie", "");
      this.$set(this.imageFrom, "imageObj", []);
      this.$refs.form.resetFields();
    },
    funcSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const rLoading = this.openLoading();
          const data = this.form;
          data.imgUrl =
            this.imageFrom.renche +
            "," +
            this.imageFrom.jiaojie +
            "," +
            this.imageFrom.imageObj.join(",");
          data.time = parseTime(new Date());
          orderDetailfill(data)
            .then((response) => {
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherSubmitMethod", this.pageType);
              rLoading.close();
            })
            .then(() => this.$refs["form"].resetFields());
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", this.pageType);
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
